// extracted by mini-css-extract-plugin
module.exports = {"card":"PremiumArticleSectionCard_card__N9QRg","cardBody":"PremiumArticleSectionCard_cardBody__1_GUk","cardTitle":"PremiumArticleSectionCard_cardTitle__1CxYQ"};